import { api_base } from '../api';
import { toast } from '../../scripts/toast';

export const PromoCodes = {
	apply(user, code, cb) {
		$.ajax({
			url: api_base + '/users/me/shoppingCart/applycode',
			method: 'GET',

			success: function (res) {
				cb(res);
			},

			error: function (err) {
				if (err.status == 500) {
					return toast({
						title: 'Servidor',
						content: 'Problemas con el servidor.'
					});
				}
			}
		});
	},

	applyPublic(user, code, product_has_promo, cb) {
		var url = api_base;
		var headers = {};

		if (product_has_promo) {
			return toast({
				title: 'Código de Promoción',
				content: 'No se puede aplicar el descuento debido a que uno de los productos ya tiene descuento'
			});
		}

		if (user) {
			// Route if the usre isn authenticated.
			url += '/getcodeinfo/auth/' + code;
			headers.Authorization = 'Bearer ' + user.token;
		} else {
			// Default route.
			url += '/getcodeinfo/' + code;
		}

		$.ajax({
			url: url,
			method: 'GET',
			headers: headers,

			success: function (res) {
				cb(res);

				if (res.discount == 0) {
					return toast({
						title: 'Código de Promoción',
						content: 'El código ha expirado'
					});
				}

				toast({
					title: 'Código de Promoción',
					content: 'El código es válido'
				});
			},

			error: function (err) {
				if (err.status == 500) {
					return toast({
						title: 'Servidor',
						content: 'Problemas con el servidor.'
					});
				}

				if (err.status == 403) {
					return toast({
						title: 'Código',
						content: 'El código ya ha sido utilizado'
					});
				}

				toast({
					title: 'Código de Promoción',
					content: 'El código no es válido'
				});

				// console.log(err);
			}
		});
	}
}



// WEBPACK FOOTER //
// ./src/store/api/promo_code.js